import ModalCloseIcon from '@/assets/imgs/modal_close.svg?react';
import ModalFactory from '../modal-factory/es';
import { ModalProps, ThemeConfig } from 'antd';
import { ConfigProviderProps } from 'antd/es/config-provider';
import zhCN from 'antd/locale/zh_CN';

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

/**
 * antd 主题配置
 *  token 主题变量可以从 https://ant.design/theme-editor-cn 获取和展示
 */
export const customTheme: ThemeConfig = {
  token: {
    colorPrimary: '#FA8846',
    colorLink: '#FA8846',
    // colorPrimary: '#1677ff',
    // colorLink: '#1677ff',
  },
};
export const ConfigProviderContext = {
  theme: customTheme,
  locale: zhCN,
  // renderEmpty: () => <Empty />,
  button: { autoInsertSpace: false },
};

export const defaultModalProps: ModalProps & {
  configProviderContext?: ConfigProviderProps;
} = {
  wrapClassName: 'modal-overlay',
  centered: true,
  closeIcon: <ModalCloseIcon />,
  configProviderContext: ConfigProviderContext,
  width: 400,
};

export default function CommonModalFactory<
  T = any, // data类型
  S = any, // onOk返回值类型
  R = any
>(...props: Parameters<typeof ModalFactory<T, S, R>>): ReturnType<typeof ModalFactory<T, S, R>> {
  props[0].wrapClassName = props[0].wrapClassName ? `${defaultModalProps.wrapClassName} ${props[0].wrapClassName}` : defaultModalProps.wrapClassName;
  props[0] = Object.assign({}, defaultModalProps, props[0]);
  return ModalFactory<T, S, R>(...props);
}
